export default __webpack_public_path__ + "static/media/SUPRYNOWICZ.ff8dc520.jpg";